import { get, keys, set } from './DataStore';
import { updatePreferences } from '../actions';

export function getPreferences() {
  return (
    get(keys.PREFERENCES) ?? {
      theme: 'auto',
      colorL: 0,
      colorD: 0,
      blackDarkBg: 0,
      barsPosition: 'bottom',
      blurNSFW: true,
      centeredLayout: false,
    }
  );
}

export function setPreference(name, value) {
  const prefs = getPreferences();
  prefs[name] = value;
  set(keys.PREFERENCES, prefs);
  updatePreferences(prefs);
}
